const hasWebSockets = function() {
	return typeof global.WebSocket !== "undefined";
};

const hasFlexbox = function() {
	return (
		global.CSS && global.CSS.supports && global.CSS.supports("display", "flex")
	);
};

const hasFlexWrap = function() {
	return (
		global.CSS &&
		global.CSS.supports &&
		global.CSS.supports("flex-wrap", "wrap")
	);
};

const hasCookiesEnabled = function() {
	if (!global.navigator || !global.navigator.cookieEnabled) {
		return false;
	}
	if (!global.document) {
		return global.navigator.cookieEnabled;
	}
	try {
		const key = "ba_cookie_test";
		global.document.cookie = key + "=1";
		const enabled = global.document.cookie.indexOf(key + "=") !== -1;
		global.document.cookie = key + "=; expires=" + new Date(0).toUTCString();
		return enabled;
	} catch (ex) {
		return false;
	}
};

const isSupportedBrowser = function() {
	try {
		new Map([]); // eslint-disable-line no-new
	} catch (ex) {
		return false;
	}
	return hasWebSockets() && hasFlexbox() && hasFlexWrap();
};

const checkVersion = function(trainerVersion, currentVersion) {
	if (currentVersion === "dev") {
		return true;
	} else if (!currentVersion) {
		return false;
	} else if (!trainerVersion) {
		return true;
	}
	const trainerVersionNums = trainerVersion.split(".").map(n => parseInt(n));
	const vNums = currentVersion.split(".").map(n => parseInt(n));
	for (let i = 0; i < 3; i++) {
		const diff = vNums[i] - trainerVersionNums[i];
		if (diff) {
			return diff > 0;
		}
	}
	//Both versions are the same
	return true;
};

module.exports = {
	hasWebSockets,
	hasFlexbox,
	hasFlexWrap,
	hasCookiesEnabled,
	isSupportedBrowser,
	checkVersion,
};
